import React from "react";
import { MODALIDADES } from "../../constants";
import {
  sanitizeNonNegativeInput,
} from "../../utils/nonNegativeInput";
import { DEFAULT_PLATFORMS } from "../../services/platformCatalog";
import { getCurrencyLabel, getPlatformCurrency } from "../../services/currency";

/**
 * Tournament form component for creating/editing tournaments
 */
export const TournamentForm = ({
  form,
  errors,
  onSubmit,
  onCancel,
  isEditing,
  onChange,
}) => {
  const naturalCurrency = getPlatformCurrency(form.plataforma);
  const handleChange = (field, value) => {
    onChange({ ...form, [field]: value });
  };

  return (
    <div className="panel">
      <h2 className="form-title">
        ♣ {isEditing ? "Editar Torneio" : "Criar Novo Torneio"}
      </h2>
      <div className="tournament-form-grid">
        <div>
          <label className="field-label">Nome do Torneio</label>
          <input
            className="input-field"
            type="text"
            placeholder="Ex: Sunday Main Event"
            maxLength={50}
            value={form.nome}
            onChange={(e) => handleChange("nome", e.target.value)}
          />
          {errors.nome && <div className="field-error">{errors.nome}</div>}
        </div>

        <div>
          <label className="field-label">Buy-in ({getCurrencyLabel(naturalCurrency)})</label>
          <input
            className="input-field"
            type="number"
            min="0"
            placeholder="Ex: 500"
            maxLength={9}
            value={form.buyin}
            onChange={(e) =>
              handleChange("buyin", sanitizeNonNegativeInput(e.target.value, 9))
            }
          />
          {errors.buyin && <div className="field-error">{errors.buyin}</div>}
        </div>

        <div>
          <label className="field-label">Plataforma</label>
          <select
            className="input-field"
            value={form.plataforma}
            onChange={(e) => handleChange("plataforma", e.target.value)}
          >
            <option value="">Selecione...</option>
            {DEFAULT_PLATFORMS.map((platform) => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
          </select>
          {errors.plataforma && (
            <div className="field-error">{errors.plataforma}</div>
          )}
        </div>

        <div>
          <label className="field-label">Modalidade</label>
          <select
            className="input-field"
            value={form.modalidade}
            onChange={(e) => handleChange("modalidade", e.target.value)}
          >
            {MODALIDADES.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </div>

        {form.modalidade === "SAT" && (
          <div>
            <label className="field-label">
              Valor do Ticket ({getCurrencyLabel(naturalCurrency)})
            </label>
            <input
              className="input-field"
              type="number"
              min="0"
              placeholder="Ex: 550"
              maxLength={9}
              value={form.valorTicket}
              onChange={(e) =>
                handleChange("valorTicket", sanitizeNonNegativeInput(e.target.value, 9))
              }
            />
          </div>
        )}
      </div>

      <div className="form-actions">
        <button className="btn-ghost" onClick={onCancel}>
          Cancelar
        </button>
        <button className="btn-red btn-confirm-action" onClick={onSubmit}>
          {isEditing ? "Salvar Alterações" : "Criar Torneio"}
        </button>
      </div>
    </div>
  );
};

export default TournamentForm;
